module.exports = __webpack_public_path__ + "img/becomeapartner.b34f3302.jpg";